import { render, staticRenderFns } from "./vistadecomprasmedicina.vue?vue&type=template&id=b7eaf366"
import script from "./vistadecomprasmedicina.vue?vue&type=script&lang=js"
export * from "./vistadecomprasmedicina.vue?vue&type=script&lang=js"
import style0 from "./vistadecomprasmedicina.vue?vue&type=style&index=0&id=b7eaf366&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports